/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



//////////////////
// WEBPACK FOOTER
// ./node_modules/symbol-observable/index.js
// module id = 768
// module chunks = 1 2 3